/* WeQuote Dev Board — Archived (renderArchived, faithful port): master–detail,
 * each card with its required archive reason; Restore sends it back. */
import React, { useEffect, useState } from 'react'
import { useDevBoard } from '../DevBoardProvider'
import * as M from '../core/mutations'
import type { Feature } from '../core/types'
import { custLabel, reqCount } from '../core/logic'
import { DetailTabs, SourceLine } from './parts'
import { IcRestore } from '../icons'

const Row: React.FC<{ feat: Feature; selected: boolean; onClick: () => void }> = ({ feat, selected, onClick }) => (
  <div className={'dv-row' + (selected ? ' selected' : '')} onClick={onClick}>
    <div className="dv-row-top"><span className="rv-tag arch">ARCHIVED</span><span className="dv-row-title">{feat.title}</span></div>
    {feat.archiveReason && <div className="rv-who">Reason: {feat.archiveReason}</div>}
    {feat.notes && <div className="rv-preview">{feat.notes}</div>}
  </div>
)

const Read: React.FC<{ feat: Feature }> = ({ feat }) => {
  const { mutate } = useDevBoard()
  return (
    <>
      <div className="rv-actions"><button className="rv-act add" onClick={() => mutate((fs) => M.unarchive(fs, feat.id))}><IcRestore size={12} /> Restore</button></div>
      <div className="dv-d-top">
        <div className="dv-d-heading"><span className="rv-tag arch">ARCHIVED</span><h2 className="dv-d-title">{feat.title}</h2></div>
      </div>
      {feat.archiveReason && <div className="dv-d-pills"><span className="status-pill s-archived">Archived: {feat.archiveReason}</span></div>}
      <div className="dv-d-meta">
        <div className="dv-d-cell"><span className="dv-d-k">Customer(s)</span><span className="dv-d-v">{custLabel(feat)}</span></div>
        <div className="dv-d-cell"><span className="dv-d-k">Requests</span><span className="dv-d-v">{reqCount(feat)}</span></div>
      </div>
      <div className="dv-d-sec"><DetailTabs feat={feat} /><SourceLine feat={feat} /></div>
    </>
  )
}

export const ArchivedView: React.FC = () => {
  const { cards } = useDevBoard()
  const items = cards.filter((f) => f.status === 'archived')
  const [selectedId, setSelectedId] = useState<number | null>(null)
  useEffect(() => {
    if (selectedId !== null && !items.some((f) => f.id === selectedId)) setSelectedId(null)
    if (selectedId === null && items.length) setSelectedId(items[0].id)
  }, [items, selectedId])
  const sel = selectedId != null ? items.find((f) => f.id === selectedId) || null : null
  return (
    <div id="archivedView" style={{ padding: '16px 24px' }}>
      <p className="rv-intro">Requests you’ve archived. Select any to see why it was archived, and restore it to send it back into the flow.</p>
      <div className={'dv-wrap' + (sel ? ' has-selection' : '')}>
        <div className="dv-list">
          {items.length === 0
            ? <div className="dv-empty-list">No archived requests.</div>
            : items.map((f) => <Row key={f.id} feat={f} selected={f.id === selectedId} onClick={() => setSelectedId(f.id)} />)}
        </div>
        <div className="dv-detail">{sel && <Read feat={sel} />}</div>
      </div>
    </div>
  )
}
